import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import outlet from '@/store/ECommerce/outlet.module'
import text from '@/store/Default/text.module'
import form from '@/store/Default/form.module'
import settings from '@/store/Default/settings.module'
import guard from '@/store/Default/guard.module'
import profile from '@/store/Default/profile.module'
import basket from '@/store/Default/basket.module'
import order from '@/store/Default/order.module'
import vue from '@/store/Default/vue.module'

axios.interceptors.request.use(function (config) {
  // config.headers.subdomain = window.location.host.split('.')[0]
  // config.headers.token = store.getters.token ? store.getters.token : token
  config.headers.identity = store.getters.identity
  config.headers.clientInfo = store.getters.clientInfo
  config.headers.guardPass = store.getters.guardPass || ''
  return config
})

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {text, settings, form, guard, profile, basket, outlet, order, vue}
  // modules: { text, settings, guard, profile, vue },
})

export default store
